<template>
  <b-modal
    id="confirmation-modal"
    ref="confirmationModal"
    :title="title"
    :ok-title="$t('Ok')"
    ok-variant="primary"
    :cancel-title="$t('Cancel')"
    cancel-variant="secondary"
    @ok="ok"
    @cancel="cancel"
    @close="cancel"
    @hidden="cancel"
    >
    <p class="my-4">{{messageComputed}}</p>
  </b-modal>
</template>

<script>
export default {
  data () {
    return {
      messageData: ''
    }
  },
  computed: {
    messageComputed () {
      return this.messageData || this.message
    }
  },
  props: {
    message: {
      type: String,
      default: function () {
        return this.$t('are_you_sure')
      }
    },
    title: {
      type: String,
      default: function () {
        return this.$t('are_you_sure')
      }
    }
  },
  methods: {
    lmShow () {
      this.$refs['confirmationModal'].show()
      return new Promise((resolve, reject) => {
        this.$on('ok', () => {
          resolve('ok')
        })
        this.$on('cancel', () => {
          // eslint-disable-next-line
          reject('cancel')
        })
      })
    },
    setMessageProps (message) {
      this.messageData = message
    },
    ok () {
      this.$emit('ok')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
